export default "/_next/static/images/a1ad3c08d93e42fef816d546e92e6ea9.jpg";